import { render, staticRenderFns } from "./CompanyWalletPointIssue.vue?vue&type=template&id=92c822fa&scoped=true"
import script from "./CompanyWalletPointIssue.vue?vue&type=script&lang=js"
export * from "./CompanyWalletPointIssue.vue?vue&type=script&lang=js"
import style0 from "./CompanyWalletPointIssue.vue?vue&type=style&index=0&id=92c822fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c822fa",
  null
  
)

export default component.exports